const capitalize = (string) => {
  if (!string || string === '') return string;
  if (typeof string !== 'string') return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * @description Replaces all instances of "%s" in the string with the strings in the list.
 * TODO: Remove this as part of consolidating approach on variable replacement in translated strings
 * (https://github.com/PlentifulApp/plentiful/issues/1634)
 * @param {*} string - String to replace "%s" with.
 * @param {*} stringList - List of strings to replace "%s" with.
 */
const formatTranslation = (string, stringList) => {
  for (let i = 0; i < stringList.length; i++) {
    string = string.replace('%s', stringList[i]);
  }
  return string;
};

module.exports = {
  capitalize,
  formatTranslation,
};
